<template>
    <b-overlay :show="show" rounded="sm">
        <span>
            <b-card no-body>
                <b-card-header>
                    <b-row>
                        <b-col sm="12">
                            <h3>Editar Tutorial</h3>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-card-body>
                    <b-form>
                        <b-row>
                            <b-col sm="12" md="8">
                                <b-form-group label="Título: *">
                                    <b-input-group class="mb-3">
                                        <b-form-input type="text" placeholder="Título Tutorial"
                                            v-model="$v.form.titulo.$model" :state="chkState('titulo')"
                                            class="form-control" />
                                        <b-form-invalid-feedback id="input1LiveFeedback1">Título é
                                            obrigatório.</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group label="Status:">
                                    <b-form-radio-group v-model="$v.form.status.$model" :state="chkState('status')"
                                        id="radio-slots" :options="options" name="radio-options-slots" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <hr>
                        <b-row>
                            <b-col sm="12" md="6">
                                <b-form-group tabindex="0" label="Item Tutorial: ">
                                    <b-form-select v-model.trim="form.item" placeholder="Item" class="mb-3">
                                        <option :value="null" selected> Selecione </option>
                                        <option v-for="item in option_itens" :key="item.tipo" :value="item.tipo">
                                            {{ item.nome }}</option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="6">
                                <div class="adicionarItem">
                                    <b-button variant="success" :disabled="disable_buttons" @click="adicionarItem"><i
                                            class="fa fa-plus"></i>
                                        Adicionar</b-button>
                                </div>
                            </b-col>
                        </b-row>
                        <span v-for="(item, index) in itens" :key="index">
                            <b-row v-if="item.tipo == 'TE'">
                                <b-col sm="12" md="12">
                                    <b-form-group tabindex="0" label="Texto">
                                        <template>
                                            <vue-editor tabindex="0" v-model="form.texto[index].texto"
                                                :disabled="disable_buttons" />
                                        </template>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button variant="success" :disabled="disable_buttons" @click="adicionarItem('TE')"><i
                                            class="fa fa-plus"></i>
                                        Adicionar</b-button>
                                </b-col>
                            </b-row>

                            <b-row v-if="item.tipo == 'AR'">
                                <b-col sm="12">
                                    <b-form-group tabindex="0" label="Documento:">
                                        <b-card>
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th tabindex="0">#</th>
                                                        <th tabindex="0">Nome</th>
                                                        <th tabindex="0">Ação</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="!form.files[index].files.length">
                                                        <td tabindex="0" colspan="7">
                                                            <div class="text-center p-5">
                                                                <h4>Nenhum documento adicionado</h4>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(file, i) in form.files[index].files" :key="file.id">
                                                        <td tabindex="0">{{ i + 1 }}</td>
                                                        <td tabindex="0">
                                                            <div class="filename">
                                                                {{ file.name }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span>
                                                                <b-button class="btn btn-sm btn-secondary action"
                                                                    title="Visualizar"
                                                                    @click="abrirDocumento(file.caminho)">
                                                                    <i class="fa fa-eye">&nbsp;</i>
                                                                </b-button>

                                                                <b-button class="btn btn-sm btn-primary action"
                                                                    title="Excluir" @click.prevent="removeAnexo(i, index)">
                                                                    <i class="fa fa-times">&nbsp;</i>
                                                                </b-button>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div class="upload" tabindex="0">
                                                <file-upload class="btn btn-primary" extensions="*" accept="*"
                                                    :multiple="true" :maximum="5" :size="10000000" :add-index="true"
                                                    v-model="form.files[index].files" :disabled="disable_buttons"
                                                    :input-id="'file' + index"
                                                    @input-filter="inputFilter(index, $event)" @input-file="inputFile(index, $event)" ref="upload">
                                                    <i class="fa fa-plus">&nbsp;</i>Selecionar documentos
                                                </file-upload>
                                            </div>
                                        </b-card>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button variant="success" :disabled="disable_buttons" @click="adicionarItem('AR')"><i
                                            class="fa fa-plus"></i>
                                        Adicionar</b-button>
                                </b-col>
                            </b-row>
                            <b-row v-if="item.tipo == 'SV'">
                                <b-col cols="12">
                                    <b-form-group label="Url do Vídeo:">
                                        <b-form-input type="text" class="form-control" placeholder="Url do Vídeo"
                                            autocomplete="url" v-model="form.video_url[index].video_url"
                                            :disabled="disable_buttons"/>
                                        <b-form-invalid-feedback id="input1LiveFeedback9">Url do vídeo é
                                            obrigatória.</b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button variant="success" :disabled="disable_buttons" @click="adicionarItem('SV')"><i
                                            class="fa fa-plus"></i>
                                        Adicionar</b-button>
                                </b-col>
                            </b-row>
                            <b-row v-if="item.tipo == 'UV'">
                                <b-col sm="12" md="12">
                                    <label tabindex="0"><strong>Upload Vídeo:</strong></label>
                                    <b-form-group label-for="nome-input" invalid-feedback="Banner é obrigatório!">
                                        <b-form-file v-on:change="uploadArquivo(index, $event)"
                                            v-model="form.video_upload[index].video_upload" browse-text="Selecione"
                                            :disabled="disable_buttons"
                                            :placeholder="form.video_upload[index].video_upload ? form.video_upload[index].video_upload : 'Selecione um arquivo de video'"
                                            tabindex="0">
                                        </b-form-file>
                                    </b-form-group>
                                    <p><a :href="form.video_upload[index].url_video" target="_blank">Ver Vídeo</a></p>
                                </b-col>
                                <b-col>
                                    <b-button variant="success" :disabled="disable_buttons" @click="adicionarItem('UV')"><i
                                            class="fa fa-plus"></i>
                                        Adicionar</b-button>
                                </b-col>
                            </b-row>
                            <b-col class="col-sm-12">
                                <b-row>
                                    <b-col md="8">
                                    </b-col>
                                    <b-col class="botoes-secao">
                                        <b-button class="btn-pergunta-actions" variant="danger" :disabled="disable_buttons"
                                            v-on:click="removePergunta(index)">
                                            <i class="fa fa-minus"></i>
                                        </b-button>
                                        <b-button v-if="index !== 0" class="btn-pergunta-actions" variant="secondary"
                                            :disabled="disable_buttons" v-on:click="perguntaDown(index)">
                                            <i class="fa fa-arrow-up"></i>
                                        </b-button>
                                        <b-button v-if="index < itens.length - 1" class="btn-pergunta-actions"
                                            variant="secondary" :disabled="disable_buttons" v-on:click="perguntaUp(index)">
                                            <i class="fa fa-arrow-down"></i>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </span>
                    </b-form>
                </b-card-body>
                <b-card-footer class="p-12">
                    <b-button variant="primary" :disabled="disable_buttons" @click="onSubmit"><i class="fa fa-check"></i>
                        Salvar</b-button>
                    <b-button variant="secondary" :disabled="disable_buttons" @click="navigate('/tutoriais')"><i
                            class="fa fa-mail-reply-all"></i>
                        Voltar</b-button>
                </b-card-footer>
            </b-card>
        </span>
    </b-overlay>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import FileUpload from 'vue-upload-component'
import { VueEditor } from "vue2-editor";

miniToastr.init()

const regexUrl = new RegExp(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i);

export default {
    components: {
        FileUpload,
        VueEditor
    },
    mixins: [validationMixin],
    validations: {
        form: {
            titulo: {
                required
            },
            status: {
                required
            }
        }
    },
    created() {
        if (!this.validaPerfil()) {
            this.$router.push('/')
        }

        if (this.$route.params.id) {
            this.loadTutorial(this.$route.params.id)
        } else {
            this.navigate('/tutoriais')
        }
    },
    data() {
        return {
            selected: [],
            files: [],
            descricao: '',
            form: {
                titulo: '',
                status: true,
                item: null,
                texto: [],
                files: [],
                video_url: [],
                video_upload: [],
                documentos: []
            },
            itens: [],
            totalSize: 0,
            disable_buttons: false,
            show: false,
            options: [
                { text: 'Ativo', value: true },
                { text: 'Inativo', value: false }
            ],
            option_itens: [
                { 'tipo': 'TE', 'nome': 'Texto' },
                { 'tipo': 'AR', 'nome': 'Arquivo' },
                { 'tipo': 'UV', 'nome': 'Upload Vídeo' },
                { 'tipo': 'SV', 'nome': 'Streaming Vídeo' }
            ],
        }
    },
    computed: {
        isValid() {
            return !this.$v.form.$anyError
        },
        permissoes() {
            return this.$store.state.permissao.permissoes
        }
    },
    watch: {
        //
    },
    methods: {
        validaPerfil() {
            let perfil = this.$store.state.perfil.perfil
            if (perfil.is_admin_conferencia) {
                return true
            }
            return false
        },
        loadTutorial(id) {
            this.show = true

            Vue.http.get('api/tutorial/' + id).then(response => {
                var dados = response.body.data[0]

                if (dados.textos.length > 0) {
                    for (let i = 0; i < dados.textos.length; i++) {

                        this.itens[dados.textos[i].ordem] = {
                            tipo: 'TE'
                        }

                        this.form.texto[dados.textos[i].ordem] = {
                            texto: dados.textos[i].texto,
                            ordem: dados.textos[i].ordem
                        }
                    }
                }

                if (dados.arquivos.length > 0) {
                    var arquivos = []
                    for (let i = 0; i < dados.arquivos.length; i++) {
                        this.itens[dados.arquivos[i].ordem] = {
                            tipo: 'AR'
                        }                     
                    }

                    for (let i = 0; i < this.itens.length; i++) {
                        for (let e = 0; e < dados.arquivos.length; e++) {
                            if(dados.arquivos[e].ordem == i){
                               
                                arquivos.push({
                                    id: e,
                                    caminho: dados.arquivos[e].arquivo,
                                    name: 'Documento',
                                    old: true,
                                    ordem: i
                                })

                                this.form.files[i] = {
                                    files: arquivos,
                                    ordem: i
                                }
                            }
                        }
                        var arquivos = []
                    }
                }

                if (dados.url_videos.length > 0) {
                    for (let i = 0; i < dados.url_videos.length; i++) {
                        this.itens[dados.url_videos[i].ordem] = {
                            tipo: 'SV'
                        }

                        this.form.video_url[dados.url_videos[i].ordem] = {
                            video_url: dados.url_videos[i].url_video,
                            ordem: dados.url_videos[i].ordem
                        }
                    }
                }

                if (dados.upload_videos.length > 0) {
                    for (let i = 0; i < dados.upload_videos.length; i++) {

                        this.itens[dados.upload_videos[i].ordem] = {
                            tipo: 'UV'
                        }
                        this.form.video_upload[dados.upload_videos[i].ordem] = {
                            id: i,
                            video_upload: dados.upload_videos[i].upload_video,
                            ordem: dados.upload_videos[i].ordem,
                            url_video: process.env.ROOT_API1 + dados.upload_videos[i].upload_video
                        }
                    }
                }

                this.form.titulo = dados.titulo
                this.form.id = dados.id
                this.form.status = dados.situacao == '1 ' ? true : false
                this.show = false
            })
        },
        save() {

            this.show = true

            let data = {
                id: this.form.id,
                titulo: this.form.titulo,
                situacao: this.form.status,
                textos: this.form.texto,
                arquivos: this.form.documentos,
                video_upload: this.form.video_upload,
                video_url: this.form.video_url,
            }

            this.disable_buttons = true
            Vue.http.post('api/tutorial', data).then(response => {
                if (response.body.success) {
                    miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
                    miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                    this.disable_buttons = false

                    this.$router.push('/tutoriais')
                } else {
                    this.disable_buttons = false
                    this.show = false

                    miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                    miniToastr.error(response.body.msg, 'Erro!', 7000)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        confirmar() {
            this.$bvModal.msgBoxConfirm('Confirma o cadastro de Tutorial?', {
                okTitle: 'Confirmar',
                cancelTitle: 'Cancelar'
            }).then(valor => {
                if (valor) {
                    this.save()
                }
            }).catch(erro => {
                console.log(erro)
            })
        },
        adicionarItem(item = null) {

            if (this.form.item == 'TE' || item == 'TE') {
                this.itens.push({
                    tipo: 'TE',
                })

                this.form.texto[this.itens.length - 1] = {
                    tipo: 'TE',
                    texto: '',
                    ordem: this.itens.length - 1
                }
            }

            if (this.form.item == 'AR' || item == 'AR') {
                this.itens.push({
                    tipo: 'AR',
                })

                this.form.files[this.itens.length - 1] = {
                    tipo: 'AR',
                    files: [],
                    ordem: this.itens.length - 1
                }
            }

            if (this.form.item == 'SV' || item == 'SV') {
                this.itens.push({
                    tipo: 'SV',
                })

                this.form.video_url[this.itens.length - 1] = {
                    tipo: 'SV',
                    video_url: '',
                    ordem: this.itens.length - 1
                }
            }

            if (this.form.item == 'UV' || item == 'UV') {
                var count = 0
                for (let i = 0; i < this.itens.length; i++) {
                    if (this.itens[i].tipo == 'UV') {
                        count++
                    }
                }

                if (count == 5) {
                    miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                    miniToastr.error('Limite de upload de até 5 vídeos!', 'Alerta', 5000)
                    return false
                }

                this.itens.push({
                    tipo: 'UV',
                })

                this.form.video_upload[this.itens.length - 1] = {
                    tipo: 'UV',
                    video_upload: '',
                    ordem: this.itens.length - 1
                }
            }

            this.form.item = null
        },
        removePergunta(index) {
            switch (this.itens[index].tipo) {
                case 'TE':
                    this.$delete(this.form.texto, index)
                    break;
                case 'AR':
                    this.$delete(this.form.files, index)
                    break;
                case 'SV':
                    this.$delete(this.form.video_url, index)
                    break;
                case 'UV':
                    this.$delete(this.form.video_upload, index)
                    break;
            }
            this.$delete(this.itens, index)
            this.reordenarPerguntas()
        },
        reordenarPerguntas() {
            var dados_texto = this.form.texto
            var dados_files = this.form.files
            var dados_video_url = this.form.video_url
            var dados_video_upload = this.form.video_upload

            var cont = 0
            var contFile = 0
            var contVideo = 0
            var contUpload = 0

            this.form.texto = []
            this.form.files = []
            this.form.video_url = []
            this.form.video_upload = []

            for (let i = 0; i < this.itens.length; i++) {
                switch (this.itens[i].tipo) {
                    case 'TE':
                        if (dados_texto.length > 0) {
                            dados_texto.sort()
                            if (dados_texto[cont] !== undefined) {
                                this.form.texto[i] = {
                                    texto: dados_texto[cont].texto,
                                    tipo: dados_texto[cont].tipo,
                                    ordem: i
                                }
                            }

                            cont++
                        }

                        break;
                    case 'AR':
                        if (dados_files.length > 0) {
                            dados_files.sort()
                            if (dados_files[contFile] !== undefined) {
                                this.form.files[i] = {
                                    files: dados_files[contFile].files,
                                    tipo: dados_files[contFile].tipo,
                                    ordem: i
                                }
                            }
                            contFile++
                        }
                        break;
                    case 'SV':
                        if (dados_video_url.length > 0) {
                            dados_video_url.sort()
                            if (dados_video_url[contVideo] !== undefined) {
                                this.form.video_url[i] = {
                                    video_url: dados_video_url[contVideo].video_url,
                                    tipo: dados_video_url[contVideo].tipo,
                                    ordem: i
                                }
                            }
                            contVideo++
                        }
                        break;
                    case 'UV':
                        if (dados_video_upload.length > 0) {
                            dados_video_upload.sort()
                            if (dados_video_upload[contUpload] !== undefined) {
                                this.form.video_upload[i] = {
                                    video_upload: dados_video_upload[contUpload].video_upload,
                                    tipo: dados_video_upload[contUpload].tipo,
                                    ordem: i
                                }
                            }
                            contUpload++
                        }
                        break;
                }
            }
        },
        removeAnexo(i, index) {
            this.form.files[index].files.splice(i, 1)
            this.form.item = 'AR'
            this.form.item = null
        },
        perguntaUp(index) {
            this.ordena(this.itens, index, +1)
        },
        perguntaDown(index) {
            this.ordena(this.itens, index, -1)
        },
        ordena(array, index, delta) {
            var newIndex = index + delta
            if (newIndex < 0 || newIndex === array.length) return
            var indexes = [index, newIndex].sort((a, b) => a - b)

            array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]])

            this.reordenarPerguntas()
        },
        onSubmit() {
            if (this.validate() && this.validateRecursos()) {
                this.confirmar()
            }
        },
        chkState(val) {
            const field = this.$v.form[val]
            return !field.$dirty || !field.$invalid
        },
        findFirstError(component = this) {
            if (component.state === false) {
                if (component.$refs.input) {
                    component.$refs.input.focus()
                    return true
                }
                if (component.$refs.check) {
                    component.$refs.check.focus()
                    return true
                }
            }
            let focused = false
            component.$children.some((child) => {
                focused = this.findFirstError(child)
                return focused
            })

            return focused
        },
        validate() {
            this.$v.$touch()
            this.$nextTick(() => this.findFirstError())

            if (this.form.files.length > 0) {
                this.form.documentos = []
                var arrayFiles = this.form.files.filter(function (i) {
                    return i;
                });

                for (let i = 0; i < arrayFiles.length; i++) {
                    for (let e = 0; e < arrayFiles[i].files.length; e++) {
                        if (!arrayFiles[i].files[e].old) {
                            let reader = new FileReader()
                            reader.readAsDataURL(arrayFiles[i].files[e].file)
                            reader.onload = () => {
                                this.form.documentos.push({ base64: reader.result, nome: arrayFiles[i].files[e].name, tipo: arrayFiles[i].files[e].type, ordem: arrayFiles[i].ordem })
                            }
                        } else {
                            this.form.documentos.push({ 
                                caminho: arrayFiles[i].files[e].caminho, 
                                id: arrayFiles[i].files[e].id, 
                                name: arrayFiles[i].files[e].name, 
                                old: arrayFiles[i].files[e].old, 
                                ordem: arrayFiles[i].ordem, 
                            })
                        }
                    }
                }
            }

            return this.isValid
        },
        validateRecursos() {

            if (!this.form.texto.length && !this.form.files.length && !this.form.video_url.length && !this.form.video_upload.length) {
                miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                miniToastr.error('É necessário ter pelo menos um item!', 'Alerta', 5000)
                return false
            }

            let valid = true
            if (this.form.texto.length > 0) {
                this.form.texto.forEach(element => {
                    if (element.texto == '') {
                        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                        miniToastr.error('Campo Texto não pode ser vazio!', 'Alerta', 5000)
                        valid = false
                    }
                });
            }
            if (this.form.files.length > 0) {
                this.form.files.forEach(file => {
                    if (!file.files.length) {
                        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                        miniToastr.error('Campo Documento não pode ser vazio!', 'Alerta', 5000)
                        valid = false
                    }
                });
            }
            if (this.form.video_url.length > 0) {
                this.form.video_url.forEach(url => {
                    if (url.video_url == '') {
                        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                        miniToastr.error('Campo Url do Vídeo não pode ser vazio!', 'Alerta', 5000)
                        valid = false
                    }
                    if (!regexUrl.test(url.video_url)) {
                        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                        miniToastr.error('Url do Vídeo é inválida!', 'Alerta', 5000)
                        valid = false
                    }
                });
            }

            if (this.form.video_upload.length > 0) {
                this.form.video_upload.forEach(video => {
                    if (!video.video_upload.length) {
                        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                        miniToastr.error('Campo Upload de Vídeo não pode ser vazio!', 'Alerta', 5000)
                        valid = false
                    }
                });
            }

            return valid
        },
        inputFilter(index) {

            if (this.form.files[index].files.length === 5) {
                miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                miniToastr.error('Limite de até 5 arquivos!', 'Alerta', 5000)
                return false
            }

            this.form.item = 'AR'
            this.form.item = null
        },
        inputFile(index, newFile) {
            if (newFile) {
                let valid = true
                
                if (newFile.type == 'video/mp4' || newFile.type == 'video/avi' || newFile.type == 'video/m4v') {
                    miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                    miniToastr.error('Formato de documento inválido', 'Erro!', 7000)
                    return false
                }

                let firstTest = parseInt(this.totalSize + newFile.size)

                if (firstTest >= 10000000) {
                    var arquivos = this.form.files[index];
                        arquivos.forEach(function (arquivo, e) {
                            if (arquivo.id == newFile.id) {
                                arquivos.files.splice(e, 1)
                            }
                        })
                    
                    this.form.files[index] = arquivos
                    miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                    miniToastr.error('Tamanho total de documentos maior que 10MB', 'Erro!', 7000)
                    valid = false
                }

                return valid
            }
        },
        uploadArquivo(index, evento) {

            let arquivo = evento.target.files || evento.dataTransfer.files

            if (!arquivo.length) {
                return false
            }

            if (arquivo[0].type !== 'video/mp4' && arquivo[0].type !== 'video/avi' && arquivo[0].type !== 'video/m4v') {
                miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                miniToastr.error('Formato de video inválido', 'Erro!', 7000)
                return false
            }

            if (arquivo[0].size >= 10000000) {
                miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
                miniToastr.error('Tamanho do vídeo não pode ser maior que 10MB', 'Erro!', 7000)
                return false
            }

            let reader = new FileReader()

            reader.onload = (evento) => {
                this.form.video_upload[index].video_upload = evento.target.result
            }
            reader.readAsDataURL(arquivo[0])
        },
        navigate(route) {
            this.$router.push(route)
        },
        abrirDocumento(documento) {
            window.open(process.env.ROOT_API1 + documento, '_blank')
        }
    }
}
</script>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>

<style>
.adicionarItem {
    margin-top: 5%;
}

.botoes-secao {
    text-align: right;
}

.editr .editr--toolbar div .vw-btn-code {
    display: none;
}

.editr--content img {
    max-width: 500px;
}

.ql-snow .ql-tooltip {
    margin-left: 40%;
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/tutoriais/TutorialEditar.vue